import dayjs from 'dayjs'
import { FileAPI } from './FileAPI'

export const UserFileUploadAPI = {
    async uploadFiles(files, Identifier_id) {
        let allFiles = !Array.isArray(files) ? [files] : files

        const today = dayjs().format('YYYY-MM-DD')

        allFiles = allFiles.map((file) => {
            file.folder = 'user-uploads/custom-images/' + today
            return file
        })

        return await FileAPI.uploadFiles(allFiles, Identifier_id)
    },
}
